import moment from 'moment';
import { INTERCEPT_SURVEY_THRESHOLD } from 'appConstants';

const PreferencesUtil = {
  hasSurveyExpired: (date: string): boolean =>
    date === ''
      ? true
      : moment()
          .subtract(INTERCEPT_SURVEY_THRESHOLD, 'd')
          .isSameOrAfter(date),

  showSurvey: (optOut: boolean = false, date: string = ''): boolean => {
    return optOut ? false : PreferencesUtil.hasSurveyExpired(date);
  },
};

export { PreferencesUtil };
